import { useCallback, useEffect, useRef, useState } from 'react';

import { getCollectionCardLayouts } from '../services/cardLayouts';
import { isTokenValid } from '../utils';

/**
 * The TABLE layout that applies to each card of a collection — which columns
 * the item table shows — cascaded on the server (user → collection → card),
 * in one request. `useTileLayouts`' twin for kind 'table'.
 *
 * `enabled` defers the request until the table is actually on screen: the
 * grid never reads these, and a layout is a refinement, never a reason to
 * hold a list back — `layouts` is `{}` until it lands, which is the default
 * columns.
 */
export default function useTableLayouts(collectionId, cardsVersion = 0, { enabled = true } = {}) {
	const [layouts, setLayouts] = useState({});
	const [loaded, setLoaded] = useState(false);
	const requestRef = useRef(0);

	const refresh = useCallback(() => {
		if (!enabled || !collectionId || !isTokenValid()) {
			setLayouts({});
			setLoaded(false);
			return;
		}
		const token = ++requestRef.current;
		getCollectionCardLayouts(collectionId, 'table')
			.then(next => { if (token === requestRef.current) { setLayouts(next); setLoaded(true); } })
			.catch(() => { if (token === requestRef.current) { setLayouts({}); setLoaded(true); } });
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [collectionId, cardsVersion, enabled]);

	useEffect(refresh, [refresh]);

	return { layouts, loaded, refresh };
}
